/*
  Prevents the header cart icon from navigating to /cart on early clicks
  (e.g. right after page load) before Zipify OCU's Slide Cart Drawer script
  has finished loading and attached its own click handler to that icon.

  Without this, a fast click on the cart icon before OCU is ready just
  follows the icon's plain href to /cart, since nothing else is listening
  yet to intercept it and open OCU's drawer instead.

  Approach: hold the click, wait (briefly) for OCU's drawer container to
  exist in the DOM as a signal that OCU has mounted, then re-dispatch the
  click so OCU's own listener (which by then is attached) can handle it
  normally. If OCU never shows up within a reasonable window, fall back to
  a real navigation so the cart icon never becomes permanently unresponsive.
*/
(function () {
  var TRIGGER_SELECTOR = '.js-drawer-open-cart';
  var OCU_DRAWER_SELECTOR = '.ocu-cart-drawer';
  var MAX_WAIT_MS = 5000;
  var POLL_MS = 100;

  function ocuReady() {
    return !!document.querySelector(OCU_DRAWER_SELECTOR);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest(TRIGGER_SELECTOR);
    if (!trigger) return;

    // OCU is already mounted — its own listener handles this click normally,
    // nothing for us to do.
    if (ocuReady()) return;

    event.preventDefault();
    var fallbackHref = trigger.getAttribute('href');
    var waited = 0;

    var poll = setInterval(function () {
      if (ocuReady()) {
        clearInterval(poll);
        // Re-fire the click now that OCU's listener is attached.
        trigger.dispatchEvent(new Event('click', { bubbles: true }));
        return;
      }

      waited += POLL_MS;
      if (waited >= MAX_WAIT_MS) {
        clearInterval(poll);
        if (fallbackHref) window.location.href = fallbackHref;
      }
    }, POLL_MS);
  }, true);
})();
